import cn from 'classnames';
import { Tag } from 'primereact/tag';
import { Dispatch, SetStateAction } from 'react';

import tableStyles from '@features/campaigns/list/components/Table/CampaignsListTable.module.scss';
import { CampaignMediaType } from '@features/campaigns/shared/types/campaign.ts';
import { Icon } from '@shared/components/Icon/Icon.tsx';
import { IconVariants } from '@shared/components/Icon/IconMapper.ts';

import styles from './MediaTypePanel.module.scss';

interface MediaTypePanelIllustration {
  iconVariant: IconVariants;
  iconLabel: string;
  caption?: string;
}

interface MediaTypePanelProps {
  illustrations: MediaTypePanelIllustration[];
  description: string;
  label?: string;
  tags?: string[];
  isFullWidth?: boolean;
  isHorizontal?: boolean;
  mediaType: CampaignMediaType;
  changeHandler: Dispatch<SetStateAction<CampaignMediaType>>;
  isActive: boolean;
}

export function MediaTypePanel({
  illustrations,
  label,
  description,
  tags = [],
  isFullWidth = false,
  isHorizontal = false,
  changeHandler,
  isActive,
  mediaType,
}: MediaTypePanelProps) {
  const clickHandler = () => changeHandler(mediaType);

  return (
    <button
      className={cn(styles.wrapper, {
        [styles.active]: isActive,
        [styles.fullWidth]: isFullWidth,
        [styles.horizontal]: isHorizontal,
      })}
      type='button'
      onClick={clickHandler}
      data-testid={`create-${mediaType}-type-campaign`}
    >
      <span className={styles.indicator}></span>
      <div className={styles.iconWrapper}>
        {illustrations.map(({ iconVariant, iconLabel, caption }) => (
          <div key={iconVariant} className={cn(styles.illustration, { [styles.captioned]: caption })}>
            <Icon variant={iconVariant} iconAltText={iconLabel} />
            {caption && <p className={cn(styles.caption, styles.gradientTitle)}>{caption}</p>}
          </div>
        ))}
      </div>
      <div className={styles.contentWrapper}>
        {label && <p className={cn(styles.label, { [styles.gradientTitle]: isHorizontal })}>{label}</p>}
        <p className={styles.text}>{description}</p>
        {tags.length > 0 && (
          <div className={styles.tags}>
            {tags.map((tag) => (
              <Tag key={tag} className={tableStyles.formatValue} value={tag} />
            ))}
          </div>
        )}
      </div>
    </button>
  );
}
